import Timeago from "@stimulus-components/timeago"
import { nl } from "date-fns/locale"

export default class extends Timeago {
    get locale() {
        return nl
    }
}